import { render } from "./CommonDialog.vue?vue&type=template&id=e0b0b3b6&scoped=true&ts=true"
import script from "./CommonDialog.vue?vue&type=script&lang=ts"
export * from "./CommonDialog.vue?vue&type=script&lang=ts"

import "./CommonDialog.vue?vue&type=style&index=0&id=e0b0b3b6&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0b0b3b6"]])

export default __exports__